import React from "react";
import PricingChart from "./PricingChart";

const PriceChanges = ({ data }) => {
  // If data is undefined, return a fallback
  if (!data) {
    return <div>Loading data...</div>;
  }

  // Handle the case where there is no data
  if (data.length === 0) {
    return <div>No price changes data available.</div>;
  }

  return (
    <div>
      <h1>Price Changes</h1>
      <PricingChart data={data} />
    </div>
  );
};

export default PriceChanges;